import React from 'react';
import { Avatar, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomText from '../customText/CustomText';
import { useTranslation } from 'react-i18next';

type CustomListType = {
    list : ListElementType[],
    onClick?: Function,
    onDeleteBtn?: Function
}

const CustomList = (props: CustomListType) => {

    const {t} = useTranslation();

    const deleteItem = (e: React.MouseEvent<HTMLButtonElement>, item: ListElementType) => {
        e.stopPropagation();

        if (props.onDeleteBtn)
            props.onDeleteBtn(item);
    }
    
    return (
        <List dense={false}>
            { props.list.map((item, index) => (
                <ListItemButton
                    key={index}
                    disabled={item.isDisabled}
                    disableRipple={item.isDisabled || !props.onClick}
                    disableTouchRipple={item.isDisabled || !props.onClick}
                    sx={{
                        cursor: !item.isDisabled && (props.onClick || props.onDeleteBtn) ? 'pointer' : 'default',
                        pointerEvents: !item.isDisabled && (props.onClick || props.onDeleteBtn) ? 'auto' : 'none',
                        '&:hover': !item.isDisabled && props.onClick ? {} : {
                        backgroundColor: 'transparent',
                        },
                        '&.Mui-focusVisible': !item.isDisabled && (props.onClick || props.onDeleteBtn) ? {} : {
                        backgroundColor: 'transparent',
                        }
                    }}
                    onClick={() => !item.isDisabled && props.onClick && props.onClick(item)}>

                    <ListItem
                        secondaryAction={ props.onDeleteBtn &&
                            <IconButton edge="end" aria-label="delete" onClick={e => deleteItem(e, item)}>
                                <DeleteIcon />
                            </IconButton>
                        }
                    >

                    <ListItemAvatar>
                        <Avatar>
                            <FolderIcon />
                        </Avatar>
                    </ListItemAvatar>
                    
                    <ListItemText
                        primary={item.title}
                        secondary={`${item.description.slice(0, 45)}${item.description.length > 45 ? '...' : ''}`}
                    />
                    </ListItem>
                </ListItemButton>
            ))
            }

            { props.list.length === 0 &&
                <CustomText>{ t('general.no_element') }</CustomText>
            }
        </List>
    );
}

export default CustomList;